import { useCallback, useEffect, useState } from 'react';

export default function useHandleDragAction(target: any, name: string, fileUpload: (file: File, name: string) => void) {
  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      if (e?.dataTransfer) {
        fileUpload(e?.dataTransfer.files[0], name);
      }
    },
    [fileUpload],
  );

  const initDragEvents = useCallback((): void => {
    if (target.current !== null) {
      target.current.addEventListener('dragenter', handleDragIn);
      target.current.addEventListener('dragleave', handleDragOut);
      target.current.addEventListener('dragover', handleDragOver);
      target.current.addEventListener('drop', handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (target.current !== null) {
      target.current.removeEventListener('dragenter', handleDragIn);
      target.current.removeEventListener('dragleave', handleDragOut);
      target.current.removeEventListener('dragover', handleDragOver);
      target.current.removeEventListener('drop', handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  useEffect(() => {
    initDragEvents();

    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);
}
